<template>
  <el-tag :color="internalColor || '#FFFFFF'" :size="size">
    <span :style="{ color: bgColor(internalColor || '#FFFFFF') }">{{
      tagName
    }}</span></el-tag
  >
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'tag-display',
  computed: {
    ...mapGetters('tags', ['getTags']),
  },
  props: {
    value: {
      type: [Number, String],
    },
    size: {
      type: String,
      default: () => {
        'small';
      },
    },
  },
  data() {
    return {
      internalValue: undefined,
      internalColor: undefined,
      tagName: '',
    };
  },
  watch: {
    value(n) {
      this.internalValue = parseInt(n);
      this.internalColor = '#fff';
      this.assignName();
    },
  },
  async created() {
    this.internalValue = this.value;
    await this.fetchTags();
    this.assignName();
  },
  methods: {
    ...mapActions('tags', ['fetchTags']),
    assignName() {
      const tag = this.getTags.find((tag) => tag.id === this.internalValue);
      if (tag) {
        this.tagName = tag.label;
        this.internalColor = tag.color;
      }
    },
    bgColor(bgColor) {
      var color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      var r = parseInt(color.substring(0, 2), 16); // hexToR
      var g = parseInt(color.substring(2, 4), 16); // hexToG
      var b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    },
  },
};
</script>
